import script from "./Media.vue?vue&type=script&setup=true&lang=ts"
export * from "./Media.vue?vue&type=script&setup=true&lang=ts"

import "./Media.vue?vue&type=style&index=0&id=5c31560c&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c31560c"]])

export default __exports__